import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "./i18nResource";

const VALID_LOCALES = ['zh', 'zh_TW', 'en'];
const urlLocale = new URLSearchParams(window.location.search).get('locale');
const savedLanguage = (urlLocale && VALID_LOCALES.includes(urlLocale))
  ? urlLocale
  : (localStorage.getItem('i18nextLng') || 'zh_TW');

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: savedLanguage, // 使用保存的语言或默认语言：繁体中文
    fallbackLng: "zh_TW",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;